import React, { memo } from 'react';
import { StyleSheet } from 'react-native';
import type { CloudinaryTransformConfig } from '@sweetgreen/garnish';
import { CloudinaryImage } from '@sweetgreen/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

export const OrderCardImage = memo((props: OrderCardImageProps) => {
  const shouldUseLargerImage = useFeatureFlag(
    'MNU-3431-short-s5-image-size-updates',
  );

  const config = shouldUseLargerImage
    ? ORDER_CARD_IMG_CONFIG_LARGE
    : ORDER_CARD_IMG_CONFIG_REGULAR;

  const style = shouldUseLargerImage
    ? styles.imageWrapperLarge
    : styles.imageWrapperRegular;

  return (
    <CloudinaryImage
      baseUrl={props.assetUrl}
      config={config}
      style={style}
      accessibilityIgnoresInvertColors
    />
  );
});

// ─── Constants ──────────────────────────────────────────────────────────────────

const IMAGE_WIDTH_REGULAR = 118;
const IMAGE_HEIGHT_REGULAR = 140;
const IMAGE_WIDTH_LARGE = 118;
const IMAGE_HEIGHT_LARGE = 118;

const ORDER_CARD_IMG_CONFIG_REGULAR: CloudinaryTransformConfig = {
  crop: 'fill',
  width: 118,
  height: 140,
};

const ORDER_CARD_IMG_CONFIG_LARGE: CloudinaryTransformConfig = [
  { crop: 'crop', height: 0.6, width: 0.5 },
  { width: 118 },
];

// ─── Styles ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  imageWrapperRegular: {
    width: IMAGE_WIDTH_REGULAR,
    height: IMAGE_HEIGHT_REGULAR,
    marginTop: -6,
    marginLeft: -5,
  },
  imageWrapperLarge: {
    width: IMAGE_WIDTH_LARGE,
    height: IMAGE_HEIGHT_LARGE,
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────────

type OrderCardImageProps = Readonly<{
  assetUrl: string;
}>;
